import { type FC } from 'react';

import { type ActivityStatus } from 'connect-graphql/generated';

import AvatarGroup from '@mui/material/AvatarGroup';

import { AvatarDiscreteSize } from '@craft/ui/components/avatars';
import { Stack } from '@craft/ui/components/structural';

import { ActivityStatusAvatar } from '@/src/components/atoms/avatars/ActivityStatusAvatar';
import { DueDateChip } from '@/src/components/atoms/chips/DueDateChip';
import { ScoreChip } from '@/src/components/atoms/chips/ScoreChip';
import { UserAvatar } from '@/src/features/users/components/avatars/UserAvatar';

interface AssignedActivityStatusBarProps {
  readonly dueDate?: Date;
  readonly score?: null | number;
  readonly status: ActivityStatus;
  readonly userIds?: string[];
}

/**
 * @deprecated
 */
export const AssignedActivityStatusBar: FC<AssignedActivityStatusBarProps> = ({
  dueDate,
  score,
  status,
  userIds,
}) => (
  <Stack direction='row' gap={0.5} padding={0.5}>
    <ActivityStatusAvatar dueDate={dueDate} size={AvatarDiscreteSize.Small} status={status} />
    {!!userIds && (
      <AvatarGroup>
        {userIds.map(userId => (
          <UserAvatar key={userId} size={AvatarDiscreteSize.Small} userId={userId} />
        ))}
      </AvatarGroup>
    )}
    {!!score && <ScoreChip score={score} status={status} />}
    {dueDate && <DueDateChip dueDate={dueDate} status={status} />}
  </Stack>
);
